/**
 * Записи разговоров.
 *
 * Файл отдаётся только стримом через API с проверкой роли и поддержкой Range:
 * ни nginx-локации на каталог, ни подписанных ссылок с ключом в query (§7.6).
 * Записи — персональные данные, каталог лежит вне webroot, удаление
 * по ретеншну необратимо и пишется в audit_log.
 */
import { z } from 'zod';
import { bigIdSchema, businessDateSchema, callDispositionSchema, isoDateTimeSchema, phoneE164Schema } from './common.dto.js';
export const recordingStateSchema = z.enum(['raw', 'converting', 'ready', 'failed', 'deleted']);
export const recordingRowSchema = z.object({
    callId: bigIdSchema,
    assignmentId: bigIdSchema.nullable(),
    dispatcherId: bigIdSchema.nullable(),
    dispatcherName: z.string().nullable(),
    phone: phoneE164Schema.nullable(),
    businessDate: businessDateSchema,
    startedAt: isoDateTimeSchema,
    talkSec: z.number().int().min(0),
    disposition: callDispositionSchema,
    state: recordingStateSchema,
    durationSec: z.number().int().min(0).nullable(),
    sizeBytes: z.number().int().min(0).nullable(),
    /** Дата, после которой запись удаляется ретеншном */
    expiresAt: businessDateSchema.nullable(),
});
export const recordingsQuerySchema = z.object({
    from: businessDateSchema.optional(),
    to: businessDateSchema.optional(),
    dispatcherId: bigIdSchema.optional(),
    phone: z.string().max(32).optional(),
    state: recordingStateSchema.optional(),
    /** Только разговоры длиннее N секунд: короткие обычно антиспам, слушать нечего */
    minTalkSec: z.coerce.number().int().min(0).max(3600).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
/** GET /api/recordings/:callId — стрим mp3, ответ 200 или 206 по заголовку Range */
export const recordingParamsSchema = z.object({ callId: bigIdSchema });
/** GET /api/recordings/health — конвертер встал, если самая старая raw висит больше 30 минут */
export const recordingsHealthResponseSchema = z.object({
    rawCnt: z.number().int().min(0),
    oldestRawAgeSec: z.number().int().min(0),
    diskUsedPct: z.number().int().min(0).max(100),
    /** Запись новых разговоров остановлена по переполнению диска (§7.6) */
    recordingStopped: z.boolean(),
});
//# sourceMappingURL=recordings.dto.js.map